import React, {useEffect} from "react";
import styled from "styled-components";

import {
  AssetDataLocationObject,
  CollectionAssetDataLocationObject,
  DataLocation,
} from "common/flowmaster/types/data_location";
import {
  ActionDefinition,
  StringArgument,
  WorkflowTask,
} from "common/flowmaster/types/task_config";
import {
  Prompt,
  WorkflowContext,
  WorkflowInputs,
} from "common/flowmaster/types/workflow";
import {OrganisationId} from "common/types/organisation";
import {StringArgEditor} from "../string";

interface AssetEditorProps {
  location: AssetDataLocationObject | CollectionAssetDataLocationObject;
  onUpdateItem: (
    value: AssetDataLocationObject | CollectionAssetDataLocationObject,
  ) => void;
  priorTasks: WorkflowTask[];
  context: WorkflowContext;
  inputs: WorkflowInputs;
  prompts: Prompt[];
  actionDefinitions: ActionDefinition[];
  organisationId: OrganisationId;
  handleHasError?: (value: boolean) => void;
  disabled?: boolean;
}

const Group = styled.div``;
const GroupHeading = styled.span`
  font-size: 0.75em;
  line-height: 3em;
  color: #555;
`;

const AssetEditor: React.FC<AssetEditorProps> = ({
  location,
  onUpdateItem,
  priorTasks,
  context,
  inputs,
  prompts,
  actionDefinitions,
  organisationId,
  handleHasError,
  disabled,
}) => {
  const keyUndefined = location.key === undefined;
  const locationUndefined = location.value === undefined;
  const error = keyUndefined || locationUndefined;

  useEffect(() => {
    if (handleHasError) {
      handleHasError(error);
    }
  }, [error]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "1em",
        width: "100%",
      }}
    >
      <Group>
        <GroupHeading>Entity Id</GroupHeading>
        <StringArgEditor
          argValue={{
            value: location.entity_id as DataLocation<string>,
          }}
          priorTasks={priorTasks}
          context={context}
          inputs={inputs}
          prompts={prompts}
          actionDefinitions={actionDefinitions}
          onUpdateItem={({value}: StringArgument) => {
            onUpdateItem({
              ...location,
              entity_id: value,
            });
          }}
          organisationId={organisationId}
          useAsset={false}
          handleHasError={handleHasError}
          disabled={disabled}
        />
      </Group>
      <Group>
        <GroupHeading>Key</GroupHeading>
        <StringArgEditor
          argValue={{
            value: location.value as DataLocation<string>,
          }}
          priorTasks={priorTasks}
          context={context}
          inputs={inputs}
          prompts={prompts}
          actionDefinitions={actionDefinitions}
          onUpdateItem={({value}: StringArgument) => {
            onUpdateItem({
              ...location,
              value,
            });
          }}
          organisationId={organisationId}
          useAsset={false}
          handleHasError={handleHasError}
          disabled={disabled}
        />
      </Group>
    </div>
  );
};

export default AssetEditor;
